import { GridColumnProps } from '@progress/kendo-react-grid'
import { AccountGroupKey } from 'api/Trading-Accounts/Types/IntroducingBrokerDetailedProfileDto'
import { InputFilterCell } from 'components/Filter'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const introducingBrokerProfileAccountGroupsColumns: GridColumn[] = [
  {
    title: 'Name',
    field: AccountGroupKey.name,
    filterCell: InputFilterCell,
    show: true,
    filterable: true,
    className: 'table-columns__content',
  },
  {
    title: 'Classification Type',
    field: AccountGroupKey.classificationType,
    show: true,
    filterable: false,
    className: 'table-columns__content',
  },
  {
    title: 'Currency',
    field: AccountGroupKey.currency,
    show: true,
    filterable: false,
    className: 'table-columns__content',
  },
  {
    title: 'Tickmill Company',
    field: AccountGroupKey.tickmillCompany,
    show: true,
    filterable: false,
    className: 'table-columns__content',
  },
]

export default introducingBrokerProfileAccountGroupsColumns
